const TagData = [
    {
        name: 'ux',
        title: 'Design'
    },
    {
        name: 'front',
        title: 'UI Development'
    },
    {
        name: 'back',
        title: 'Back-end Development'
    },
    {
        name: 'flash',
        title: 'Flash Development'
    },
    {
        name: 'js',
        title: 'JavaScript Development'
    },
    {
        name: 'feature',
        title: 'Featured Components'
    },
    {
        name: 'map',
        title: 'Interactive Map'
    },
    {
        name: 'banners',
        title: 'Animated Banners'
    },
    {
        name: 'timeline',
        title: 'Animated Timeline'
    },
    {
        name: 'concept',
        title: 'Concept'
    },
    {
        name: 'video-player',
        title: 'Custom Video Player'
    },
    {
        name: 'video-production',
        title: 'Video Production'
    },
    {
        name: 'mobile',
        title: 'Mobile View'
    },
    {
        name: 'storyboard',
        title: 'Storyboard'
    },
    {
        name: 'production',
        title: 'Production'
    },
    {
        name: 'drupal',
        title: 'Drupal Development'
    },
    {
        name: 'tailwind',
        title: 'Tailwind CSS'
    },
    {
        name: 'jq',
        title: 'JQuery Components'
    },
    {
        name: 'react',
        title: 'React'
    },
    {
        name: 'angular',
        title: 'Angular'
    },
    {
        name: 'php',
        title: 'PHP'
    },
    {
        name: 'codeigniter',
        title: 'CodeIgniter'
    },
    {
        name: 'symfony',
        title: 'Symfony'
    },
    {
        name: 'twig',
        title: 'Twig'
    },
    {
        name: 'sax',
        title: 'Saxotech'
    },
    {
        name: 'mysql',
        title: 'MySQL'
    },
    {
        name: 'mongodb',
        title: 'MongoDB'
    },
    {
        name: 'data',
        title: 'Data Centers'
    },
    {
        name: 'charts',
        title: 'Data Visualization'
    },
    {
        name: 'admin',
        title: 'Custom Admin'
    },
    {
        name: 'sass',
        title: 'SCSS'
    },
    {
        name: 'sponsor',
        title: 'Sponsored Content'
    },
    {
        name: 'pnc',
        title: 'Point & Clique'
    },
    {
        name: 'mail',
        title: 'Newsletters'
    },
    {
        name: 'ga',
        title: 'Google Analytics'
    },
    {
        name: '',
        title: ''
    },
    {
        name: '',
        title: ''
    },
];

export default TagData;